import * as yup from "yup";

export const questionValidation = yup.object().shape({
  text: yup.string().required("Это поле обязательно"),
  error_text: yup.string().required("Укажите пояснение к билетам"),
  image_src: yup.string().required("Добавьте изображение к вопросу"),
});

export const videoValidation = yup.object().shape({
  name: yup.string().required("Укажите название видеоролика"),
  theme_id: yup.string().required("Укажите тему видеоролика"),
  // video_src: yup.,
  preview_src: yup.string().required("Добавьте превью видео"),
});

export const drivingLessonValidation = yup.object().shape({
  school_id: yup.number().required("Укажите автокшолу"),
  student_id: yup.number().required("Укажите студента"),
  teacher_id: yup.number().required("Укажите инструктора"),
  lesson_type: yup.number().required("Укажите тип занятия"),
  lesson_status: yup.number().required("Это поле обязательно"),
  lesson_start_time: yup.date().required("Укажите время начала"),
  lesson_end_time: yup.date().required("Укажите время конца"),
  description: yup.string(),
  category_id: yup.number().required("Укажите категорию"),
});
